import type { QueryClient } from '@tanstack/react-query';

import type { ApiError } from '@nucleus-commerce/api-client/transport';

import { session } from '@/shared/session/session';

import { TWO_FACTOR_SETUP_PATH } from './guards';

interface Navigator {
  navigate: (options: { to: typeof TWO_FACTOR_SETUP_PATH }) => Promise<void>;
}

/**
 * Transport onError: the requirement came on mid-session (the operator set
 * PLATFORM_REQUIRE_TWO_FACTOR and restarted the API). /me now says so, and the guard on the
 * refreshed session keeps the user on the setup screen.
 */
export function followTwoFactorRequirement(
  error: ApiError,
  {
    queryClient,
    router,
    pathname,
  }: { queryClient: QueryClient; router: Navigator; pathname: string },
): Promise<void> | undefined {
  if (error.code !== 'TWO_FACTOR_REQUIRED' || pathname === TWO_FACTOR_SETUP_PATH) return undefined;
  return session
    .refreshSession(queryClient)
    .then(() => undefined)
    .finally(() => router.navigate({ to: TWO_FACTOR_SETUP_PATH }));
}
